import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const AddressIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 4C8.68629 4 6 6.68629 6 10C6 12.6302 7.55095 15.1468 9.25258 17.0915C10.0884 18.0467 10.9269 18.8256 11.557 19.3657C11.7205 19.5058 11.8694 19.6294 12 19.7354C12.1306 19.6294 12.2795 19.5058 12.443 19.3657C13.0731 18.8256 13.9116 18.0467 14.7474 17.0915C16.4491 15.1468 18 12.6302 18 10C18 6.68629 15.3137 4 12 4ZM12 21C11.4188 21.8137 11.4185 21.8136 11.4182 21.8134L11.4175 21.8129L11.4157 21.8115L11.41 21.8075L11.3913 21.7939C11.3755 21.7824 11.3533 21.7661 11.3251 21.7451C11.2685 21.7031 11.1878 21.6423 11.0864 21.5637C10.8836 21.4064 10.5974 21.1773 10.2555 20.8843C9.57307 20.2994 8.66162 19.4533 7.74742 18.4085C5.94905 16.3532 4 13.3698 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 13.3698 18.0509 16.3532 16.2526 18.4085C15.3384 19.4533 14.4269 20.2994 13.7445 20.8843C13.4026 21.1773 13.1164 21.4064 12.9136 21.5637C12.8122 21.6423 12.7315 21.7031 12.6749 21.7451C12.6467 21.7661 12.6245 21.7824 12.6087 21.7939L12.59 21.8075L12.5843 21.8115L12.5825 21.8129L12.5818 21.8134C12.5815 21.8136 12.5812 21.8137 12 21ZM12 21L12.5812 21.8137C12.2335 22.0621 11.7665 22.0621 11.4188 21.8137L12 21ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

AddressIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(AddressIcon);
